import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

import { FeatureFlagService } from './feature-flag.service';
import { FeatureNames } from 'feature-flag-config/generated/feature-names';

@Directive({
  selector: '[appIfFeatureOn]'
})
export class IfFeatureOnDirective implements OnInit {
  @Input('appIfFeatureOn') featureName: FeatureNames;

  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private featureFlagService: FeatureFlagService
  ) {
  }

  ngOnInit() {
    const featureOn = this.featureFlagService.featureOn(this.featureName);
    if (featureOn && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!featureOn && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
